import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ClientUserBaseEffect } from './client-user-base.effect';
import { clientUserBaseFeature } from './client-user-base.state';

@NgModule({
  imports: [
    StoreModule.forFeature(clientUserBaseFeature),
    EffectsModule.forFeature([ ClientUserBaseEffect ])
  ]
})
export class ClientUserBaseModule {

}
